import React from "react";
import { Badge, Box, Typography } from "@bca/ui-library";
import styled from "styled-components";
import css from "@styled-system/css";

const Container = styled(Box)`
  ${css({
    borderBottom: "2px solid",
    borderColor: "secondary-orange",
  })}
`;

const PaymentProcessing = () => (
  <Container
    backgroundColor="rgba(254, 251, 245, 1);"
    paddingX={{
      mobile: "20px",
      desktop: "48px",
    }}
    paddingY="32px"
  >
    <Box paddingBottom="20px">
      <Badge label="Payment Processing" variant="warning" />
    </Box>
    <Box>
      <Typography variant="body-small">
        Your payment has not been processed yet. Once we have received
        confirmation from your bank that the payment has been made, a
        confirmation will be sent to you via email.
      </Typography>
    </Box>
  </Container>
);

export default PaymentProcessing;
